import api from './api';

const contactService = {
  // Envoyer un message de contact
  sendContactMessage: async (contactData) => {
    const response = await api.post('/contact', contactData);
    return response.data;
  }
};

export default contactService;

